export const STAGE = window.location.hostname === 'distributors.aesthetixconnect.com' ? "client-api" : "dev-api";
